import { Button, colors, Tooltip } from '@insurancemenu/imenu-components-lib';
import React, { useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Add } from '@insurancemenu/imenu-components-lib/dist/icons';
import { AlignmentTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { ModalType } from '@insurancemenu/imenu-components-lib/dist/helpers/ModalsHelper';
import { ManageConditionModalDelegate } from 'store/modules/subscriber/health-questionnaire/manageConditionModalDelegate';
import {
  AddFamilyMemberSectionStyled,
  AddFamilyMemberTextSectionStyled,
  AddFamilyMemberTextStyled,
  AddFamilyMemberTitleStyled,
  ActionModalStyled,
  ModalBodyStyled,
} from './styles';
import { HorizontalTabs } from './HorizontalTabs';

interface ManageConditionsModalProps {
  manageConditionModalDelegate: ManageConditionModalDelegate;
}

export const ManageConditionsModal: React.FC<ManageConditionsModalProps> = observer(
  ({ manageConditionModalDelegate }) => {
    const { cannotAddNewMemberReason, isLoading } = manageConditionModalDelegate;
    const scrollRef = useRef<HTMLDivElement>(null);

    const onSubmit = async (): Promise<void> => {
      await manageConditionModalDelegate.submitMemberForm();
      scrollRef.current?.scrollTo(0, 0);
    };

    const onClose = (): void => {
      manageConditionModalDelegate.close();
      scrollRef.current?.scrollTo(0, 0);
    };

    const addFamilyMemberButton = (
      <Button
        color="custom"
        customColor={colors.green[600]}
        leftIconProp={<Add />}
        size="large"
        disabled={Boolean(cannotAddNewMemberReason)}
        onClick={manageConditionModalDelegate.addNewMemberForm}
      >
        Add Family Member
      </Button>
    );

    return (
      <ActionModalStyled
        title="Manage Conditions"
        subtitle={manageConditionModalDelegate.conditionName}
        show={manageConditionModalDelegate.isVisible}
        onClose={onClose}
        onAction={onSubmit}
        modalType={ModalType.NO_ICON}
        modalContainerRef={scrollRef}
        modalContent={
          <ModalBodyStyled>
            <AddFamilyMemberSectionStyled>
              <AddFamilyMemberTextSectionStyled>
                <AddFamilyMemberTitleStyled>Does this apply to another family member?</AddFamilyMemberTitleStyled>
                <AddFamilyMemberTextStyled>
                  Add any additional members who have this condition and complete a separate set of details for each
                  person.
                </AddFamilyMemberTextStyled>
              </AddFamilyMemberTextSectionStyled>

              {cannotAddNewMemberReason ? (
                <Tooltip label={cannotAddNewMemberReason} alignment={AlignmentTypes.BOTTOM_END}>
                  {addFamilyMemberButton}
                </Tooltip>
              ) : (
                addFamilyMemberButton
              )}
            </AddFamilyMemberSectionStyled>
            <HorizontalTabs manageConditionModalDelegate={manageConditionModalDelegate} />
          </ModalBodyStyled>
        }
        actionButtonText="Save"
        closeButtonText="Cancel"
        isValid={manageConditionModalDelegate.canSubmitCurrentForm && !isLoading}
      />
    );
  },
);
